import React, {useEffect, useRef} from 'react';
import {Breadcrumb, Card, Divider, PageHeader, Typography} from 'antd';
import Flex from '../../../components/Flex';
import useCollectionWork from '../../../hooks/apis/useCollectionWork';
import CollectionWorkProjectSubmitForm from '../../../components/CollectionWorkProject/SubmitForm';
import CollectionWorkProjectRecordList, {RefreshRef} from '../../../components/CollectionWorkProjectRecord/List';
import {UserType} from '../../../hooks/apis/useUser';
import CustomerError from '../../../components/CustomerError';
import useQuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useParams} from 'react-router-dom';

export default function CollectionWorkUploadRecordPage() {
  const params = useParams() as {id?: string};
  const collectionWorkId = parseInt(params.id as string);
  const queryByIdHook = useCollectionWork.queryById();
  const listRef = useRef<RefreshRef>();
  const quickRouter = useQuickRouter();

  function refresh() {
    queryByIdHook
      .request({id: collectionWorkId})
      .then()
      .catch(CommonApiErrorHandler);
    listRef.current?.refresh();
  }

  useEffect(() => {
    collectionWorkId && refresh();
  }, [collectionWorkId]);
  const auth = useAuth();
  if (!auth.currentUser || auth.currentUser.type !== UserType.普通账号) return <CustomerError title={'无操作权限'} />;

  return (
    <Flex justify={'center'}>
      <div style={{width: 900}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(queryByIdHook.data?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card style={{margin: 20}}>
          {queryByIdHook.data && <CollectionWorkProjectSubmitForm collectionWork={queryByIdHook.data} onFinish={() => refresh()} />}
          <Divider />
          <Flex direction={'column'}>
            {queryByIdHook.data?.remark && <Typography.Text type={'secondary'}>* {queryByIdHook.data?.remark}</Typography.Text>}
            <Typography.Text type={'secondary'}>* 每个参评项目只接受一个文件，重复提交则替换旧文件。</Typography.Text>
            <Typography.Text type={'secondary'}>
              *
              以小组形式参赛的，请在在“个人信息”设置页面中，将姓名设置为小组名称，在备注栏内填写所有成员姓名（小组人数不得超过5人），设置完毕后再上传作品，否则无法正常统计。
            </Typography.Text>
            <Typography.Text type={'secondary'}>* 上传完毕后，请务必点击以下文件链接进行检查，确保可以正常打开。</Typography.Text>
          </Flex>
          <Divider />
          <Typography.Title level={5}>已提交的作品</Typography.Title>
          <CollectionWorkProjectRecordList ref={listRef} collectionWorkId={collectionWorkId} />
        </Card>
      </div>
    </Flex>
  );
}
